import {
  SensorDataApi as SensorDataApiV1,
  DataExportApi as DataExportApiV1,
} from "@veris-health/med-data-ms/lib/v1";

import config from "../axios-config";
import { API_ROUTES, getVersion, VERSIONS } from "../helpers";

export const sensorDataApiV1 = new SensorDataApiV1(
  undefined,
  getVersion(API_ROUTES.MED_DATA, VERSIONS.v1),
  config,
);

export const dataExportApiV1 = new DataExportApiV1(
  undefined,
  getVersion(API_ROUTES.MED_DATA, VERSIONS.v1),
  config,
);

// Direct axios call — not yet available in the @veris-health/med-data-ms SDK
export interface PatientIntegrationStatus {
  integrationName: string | null;
  forwardingVitals: boolean;
}

export const getPatientIntegrationStatus = async (
  patientId: number,
): Promise<PatientIntegrationStatus> => {
  const response = await config.get(
    `${getVersion(API_ROUTES.MED_DATA, VERSIONS.v1)}/admin/patients/${patientId}/integration-status`,
  );
  return {
    integrationName: response.data["integration_name"] as string | null,
    forwardingVitals: response.data["forwarding_vitals"] as boolean,
  };
};
